const config = {
  domain: process.env.REACT_APP_DOMAIN,
  api_uri: process.env.REACT_APP_API_URI,
  blog_uri: process.env.REACT_APP_BLOG_URI,
  client_id: process.env.REACT_APP_CLIENT_ID,
  recaptcha_sitekey: '6LdcQHgUAAAAAKlTFwhI1wif8DYuclk2Q07R3cwu'
}

export default config



// WEBPACK FOOTER //
// ./src/config.js